import React, { useState } from 'react';

import { useI18n } from '../../hooks/useI18n';
import { TranslationKeys } from '../../i18n/locales/defaultResources';
import PageHeader from '../../presentation/layout/PageHeader/PageHeader';
import {
  CropConnectRoleDefinitions,
  DocumentFolder,
} from '../../services/cropConnectApiClient';
import {
  DetailViewWrapper,
  LeftPlaceholder,
  MainContentWrapper,
  RightWidgetContainer,
  StyledActionButtonContainer,
} from './styles';
import ActionButton from '../../presentation/components/ActionButton/ActionButton';
import { MainContainer } from '../../styles/styles';
import DocumentList from '../../presentation/features/documents/DocumentsList/DocumentsLists';
import FinancialOverviewReport from '../../presentation/reports/FinancialOverviewReport/FinancialOverviewReport';
import SecurityTrim from '../../services/auth/SecurityTrim';
import GeneralDocumentsComponent from '../../presentation/features/general_documents/GeneralDocumentsComponent/GeneralDocumentsComponent';
import BeetPriceWidget from '../../presentation/features/databox/BeetPrice/BeetPrice';

const MyPayments: React.FC = () => {
  const { t } = useI18n();
  const [isMainView, setIsMainView] = useState(true);

  const handleBackToOverview = () => {
    setIsMainView(true);
  };

  const handleFullReportClick = () => {
    setIsMainView(false);
  };

  return (
    <MainContainer>
      <PageHeader title={t(TranslationKeys.my_payments_title)} />
      {isMainView ? (
        <MainContentWrapper>
          <LeftPlaceholder>
            <SecurityTrim
              requiredBusinessPartnerRoles={[CropConnectRoleDefinitions.Grower]}
            >
              <DocumentList
                title={t(TranslationKeys.my_payments_documents_list_title)}
                folder={DocumentFolder.MyPayments}
                onToggleView={handleFullReportClick}
                showExtraButton={true}
                hideInvoiceColumn={false}
                postingDateInsteadOfCreationDate={true}
                buttonText={t(
                  TranslationKeys.my_payments_full_financial_report
                )}
              />
            </SecurityTrim>
          </LeftPlaceholder>
          <RightWidgetContainer>
            <BeetPriceWidget />
            <GeneralDocumentsComponent parent="my-payments" />
          </RightWidgetContainer>
        </MainContentWrapper>
      ) : (
        <DetailViewWrapper>
          <StyledActionButtonContainer>
            <ActionButton
              variant="link-button"
              buttonText={t(TranslationKeys.common_back_to_overview)}
              onClickAction={handleBackToOverview}
              back={true}
            />
          </StyledActionButtonContainer>
          <LeftPlaceholder>
            <SecurityTrim
              requiredBusinessPartnerRoles={[
                CropConnectRoleDefinitions.Grower_DE,
                CropConnectRoleDefinitions.Grower_Organic_DE,
              ]}
              fallback={
                <div>{t(TranslationKeys.common_report_not_released)}</div>
              }
            >
              <FinancialOverviewReport />
            </SecurityTrim>
          </LeftPlaceholder>
        </DetailViewWrapper>
      )}
    </MainContainer>
  );
};

export default MyPayments;
